(function () {
    "use strict";
    angular.module('skillBuilderSaaS')
        .controller("AssignedGroupsCtrl", ["accountsResource", "groupHierarchyResource", "$scope", "messageService", "_", "profileRecord", "$state", "$uibModal", assignedGroupsCtrl]);
    function assignedGroupsCtrl(accountsResource, groupHierarchyResource, $scope, messageService, _, profileRecord, $state, $uibModal) {
        var vm = this;
        vm.submitting = false;
        vm.deleting = false;
        vm.availableGroups = [];
        vm.selectedGroup = null;
        var person = $state.params.personSeq;
        vm.profileRecord = profileRecord;
        groupHierarchyResource.query({ showAllGroups: false }, function (data) {
            vm.availableGroups = data;
        });
        vm.addToGroup = function () {
            vm.submitting = true;
            if (_.includes(_.pluck(vm.profileRecord.groups, 'id'), vm.selectedGroup.id)) {
                messageService.warning("account.profile.edit.userInGroupAlready");
                vm.submitting = false;
                return;
            }
            accountsResource.addToGroup({ personSeq: person, actionValue: vm.selectedGroup.id }, { userId: vm.profileRecord.id }, function () {
                messageService.success("account.profile.edit.userAddedToGroup");
                vm.submitting = false;
                vm.profileRecord.groups.push(vm.selectedGroup);
                vm.selectedGroup = null;
            }, function (error) {
                messageService.error(error);
            });
        };
        vm.removeFromGroup = function (group) {
            var modal = $uibModal.open({
                templateUrl: "removeFromGroupConfirmation.html",
                backdrop: false,
                animation: false,
                windowClass: "confirmation-modal"
            });
            modal.result.then(function () {
                vm.deleting = true;
                accountsResource.removeFromGroup({ personSeq: person, actionValue: group.id }, { userId: vm.profileRecord.id }, function () {
                    messageService.success("account.profile.edit.userRemovedFromGroup");
                    vm.deleting = false;
                    vm.profileRecord.groups = _.without(vm.profileRecord.groups, group);
                }, function (error) {
                    messageService.error(error);
                });
            }).catch(angular.noop);
        };
        vm.close = function () {
            $scope.$close(vm.profileRecord.groups);
        };
    }
}());
